import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { ArticleDetailScreen } from '@/common/ArticleDetailScreen';
import { NotFoundScreen } from '@/common/ErrorScreen';

/** A student tutorial single. No image: tutorials don't carry one. */
function StudentTutorialPost(): ReactElement | null {
  const { t } = useTranslation();
  const { slug } = Route.useParams();
  const { data, isError, isPending } = api.getStudentTutorial.useQuery({
    path: { slug },
  });

  if (isError) return <NotFoundScreen />;
  if (isPending || data === undefined) return null;

  return (
    <ArticleDetailScreen
      article={{
        title: data.title,
        content: data.content,
        date: data.published_on,
        authorName: data.author_name,
        authorAvatarUrl: data.author_avatar_url,
      }}
      // Unlike legacy's `history.back()`, the back arrow goes to the unfiltered
      // archive.
      backPath="/student-tutorials/"
      notFoundMessage={t('wbs.page-not-found')}
    />
  );
}

export const Route = createFileRoute('/_app/student-tutorials/$slug')({
  component: StudentTutorialPost,
});
